import { useNavigate } from "react-router-dom";
import { Monitor, Smartphone } from "lucide-react";

const RoleSelection = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-white mb-3">نظام النداء</h1>
        <p className="text-lg text-slate-400">اختر نوع الجهاز</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl w-full">
        {/* Cashier Screens */}
        <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700">
          <div className="flex items-center gap-3 mb-6">
            <Monitor className="w-8 h-8 text-blue-400" />
            <h2 className="text-xl font-bold text-white">شاشات الكاش</h2>
          </div>
          <div className="grid grid-cols-4 gap-2">
            {Array.from({ length: 12 }, (_, i) => i + 1).map((num) => (
              <button
                key={num}
                data-testid={`select-cash-${num}`}
                onClick={() => navigate(`/cashier/${num}`)}
                className="h-14 bg-slate-700 hover:bg-blue-600 text-white font-bold text-lg rounded-xl transition-colors"
              >
                {num}
              </button>
            ))}
          </div>
        </div>

        {/* Supervisor Mobile */}
        <button
          data-testid="select-supervisor"
          onClick={() => navigate("/supervisor")}
          className="bg-emerald-600 hover:bg-emerald-700 rounded-2xl p-6 border border-emerald-500 transition-colors text-right"
        >
          <div className="flex items-center gap-3 mb-4">
            <Smartphone className="w-8 h-8 text-white" />
            <h2 className="text-xl font-bold text-white">موبايل المشرف</h2>
          </div>
          <p className="text-emerald-100">استقبال الإشعارات والتنبيهات</p>
        </button>
      </div>
    </div>
  );
};

export default RoleSelection;
